<template>
  <RequestUpdated
    request-type="overtime"
    :notification="notification"
    :active-notification="activeNotification"
    @show-more-details="showMoreDetails"
  />
</template>

<script>
import RequestUpdated from '@/components/notifications/RequestUpdated'
import Notification from '@/components/notifications/mixins/Notification'

export default {
  name: 'OvertimeUpdated',

  components: {
    RequestUpdated,
  },

  mixins: [Notification],

  methods: {
    showMoreDetails() {
      this.$emit('click', this.notification)
    },
  },
}
</script>
